import { memo } from 'react';
import MuiAutocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';

import type {
  AutocompleteProps as MUIAutocompleteProps,
  TextFieldProps,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { InputText } from '../input-text/index';

type AutocompleteProps = Omit<
  MUIAutocompleteProps<any, any, any, any, any>,
  'renderInput'
> & {
  inputProps: TextFieldProps;
  name: string;
};

export const AutocompleteHookForm = memo<AutocompleteProps>(
  function Autocomplete({
    inputProps,
    name,
    options = [],
    ...autocompleteProps
  }: AutocompleteProps) {
    const { control } = useFormContext();

    return (
      <Controller
        control={control}
        name={name}
        render={({
          field: { ref, onChange, value, ...fieldProps },
          fieldState: { error },
        }) => (
          <MuiAutocomplete
            size="small"
            noOptionsText="Nenhum resultado encontrado"
            renderTags={(tag: readonly string[], getTagProps) => {
              return tag?.map((option: string, index: number) => (
                <Chip label={option} {...getTagProps({ index })} />
              ));
            }}
            {...autocompleteProps}
            onChange={(_, data) => onChange(data?.id)}
            value={
              value
                ? options.find((option) => option.id === value) ?? null
                : null
            }
            options={options}
            renderInput={(params) => (
              <InputText
                {...inputProps}
                {...params}
                {...fieldProps}
                inputRef={ref}
                sx={{ ...inputProps?.sx, p: 0 }}
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        )}
      />
    );
  }
);
